// extracted by mini-css-extract-plugin
export default {"card":"CardItem_card__P+IiI"};